import amenityUtils from "../amenitiesConfig/amenityUtils";

const {
  currencyOptions,
  getWeekDaysOptions,
  statusValues,
  isPositiveInteger,
  getMinutesFromHHMM,
  getAllowedHoursRange,
  isEventInDateRangeByResource,
  formatTimeToFormatedString,
  formatTimestampToProjectTimeZone,
  getClientReservationsList,
  getClientReservationsById,
  getActiveClientReservations,
  getClientReservationsDerived,
  getActiveClientReservationIds,
  getEventsByResourceId,
  getCalendarInitialDate,
  formatServiceEventsForTable,
  addColorByStatusToEvents,
  getAllowedMaxHourInCalendarView,
  getStatusColor,
  renderEventContent,
  validateServiceEventLimit,
} = amenityUtils;

const serviceUtils = {
  currencyOptions,
  getWeekDaysOptions,
  statusValues,
  isPositiveInteger,
  getMinutesFromHHMM,
  getAllowedHoursRange,
  isEventInDateRangeByResource,
  formatTimeToFormatedString,
  formatTimestampToProjectTimeZone,
  getClientReservationsList,
  getClientReservationsById,
  getActiveClientReservations,
  getClientReservationsDerived,
  getActiveClientReservationIds,
  getEventsByResourceId,
  getCalendarInitialDate,
  formatServiceEventsForTable,
  addColorByStatusToEvents,
  getAllowedMaxHourInCalendarView,
  getStatusColor,
  renderEventContent,
  validateServiceEventLimit,
};

export default serviceUtils;
